import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Button } from 'reactstrap';
import { TypedMemo } from '../../../common/types';
import { toggleSMLPricingModal } from '../../../../redux/slices/appInfo/slice';
import { monthlyAddOnMessages as messages } from './monthlyAddOnMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the add-ons panel; each part uses its own slice of it */
import styles from './MonthlyAddOns.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * A plan that sells no extra artist (Plug) has no artists slider (design monthly-addons a1): one
 * line that Plus, Pro, Max and Ultra add artists at 20 % off the plan price, and "See plans", which
 * opens the plans page as the plan card does.
 */
const MoreArtistsLineComponent: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const openPlans = useCallback(() => dispatch(toggleSMLPricingModal({ shouldShow: true })), [dispatch]);
  return (
    <div className={styles.more} data-testid="addons-more-artists">
      <span>{intl.formatMessage(messages.moreArtists)}</span>
      <Button color="link" className="p-0" onClick={openPlans}>
        {intl.formatMessage(messages.seePlans)}
      </Button>
    </div>
  );
};

export const MoreArtistsLine = TypedMemo(MoreArtistsLineComponent);
